import * as c from './constants/userTypes';

export default {
  [c.USER_TYPE_CLIENT]:         '/client',
  [c.USER_TYPE_EMPLOYEE]:       '/uc',
  [c.USER_TYPE_MC_ADMIN]:       '/mcadmin',
  [c.USER_TYPE_HOUSE_IMPORTER]: '/house-importer',
  [c.USER_TYPE_ADMIN]:          '/admin',
};
